export const PATH_CARD_SMALL_WIDTH = 300;
export const PATH_CARD_SMALL_HEIGHT = 350;
